<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <h1 class="m-0 text-dark">{{ $t('anUpdateSetting')}}</h1>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="col-12">
          <form @submit.prevent="updateSetting">
            <div class="form-group">
              <label for="input">{{ $t('table.name')}}</label>
              <br />
              {{ setting.name }}
            </div>

            <div v-if="setting.value" class="form-group">
              <label for="input">{{ $t('table.value')}}</label>
              <br />
              <input type="text" class="form-control text-left" v-model="setting.value" />
            </div>

            <div v-if="setting.metadata" class="form-group">
              <label for="input">{{ $t('table.timePeriod')}}: </label>
              <br />
              {{ setting.metadata.timePeriod }} {{ $t('table.year')}}
              <br />
              <label for="input">{{ $t('table.currency')}}: </label> {{ setting.metadata.currency }}
              <br />
              <label for="input">{{ $t('table.interest')}}: </label>
              <br />
              <input type="text" class="form-control text-left" v-model="setting.metadata.interest" />
            </div>

            <button type="submit" class="btn btn-success btn-rounded px-4">{{ $t('table.save')}}</button>
          </form>
          <h5 class="text-center text-success mt-2">{{dataSuccess}}</h5>
          <h5 class="text-center text-danger">{{dataErr}}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminSettingUpdate",
  data() {
    return {
      dataSuccess: "",
      dataErr: "",
      setting: {},
      id: null
    };
  },
  mounted() {
    this.id = this.$route.params.id
    this.getSetting()
  },
  methods: {
    getSetting() {
      this.$axios.get(`/admin/v1/priority/settings/${this.id}`)
      .then(res => {
        this.setting = res.data.data;
      })
      .catch(function(err) {
        console.log(err)
      })
    },
    updateSetting() {
      let updateParams = {}
      if(typeof this.setting.value !== 'undefined') {
        updateParams.value = this.setting.value
      }

      if(this.setting.metadata) {
        var {timePeriod, currency, interest} = this.setting.metadata
        updateParams.metadata = {
          timePeriod,
          currency,
          interest
        }
      }
      this.$axios
        .put(`/admin/v1/priority/settings/${this.id}`, updateParams)
        .then(res => {
          this.setting = res.data.data;
          this.dataSuccess = "Data Priority Setting Berhasil Disimpan";
        })
        .catch(err => {
          this.dataErr = `Data Priority Setting gagal disimpan, ${err}`;
        });
    }
  }
};
</script>